module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-earthCover"
  }, [_c('div', {
    staticClass: "c-earthCover__cover"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCoord),
      expression: "showCoord"
    }],
    staticClass: "c-earthCover__coord",
    style: ({
      backgroundPosition: _vm.backgroundPosition
    })
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTips),
      expression: "showTips"
    }],
    staticClass: "c-earthCover__tips"
  }, [_c('div', {
    staticClass: "c-earthCover__hand"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-f36dcfb2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/show/Cover.vue
// module id = 208
// module chunks = 1